module.exports = __webpack_public_path__ + "static/media/29.fb5fcfdd.jpg";